const maxRetryCount = 3;
/**
 * 
 * @param {*} retryCount
 * @returns {Promise<{id: string, password: string}>}
 * @description
 * This function creates an instant meeting and returns the meeting details.
 */
const createAndfetchMeetingDetails = async (retryCount = 0) => {
    const accessToken = localStorage.getItem('zoomAccessToken');
    console.log("Creating instant meeting...")
    // Check if accessToken is available
    if (!accessToken) {
        console.error("Access token not found.")
        return;
    }

    const response = await fetch(`${process.env.REACT_APP_CAREX_ZOOM_SERVICE_ENDPOINT}/meetings/instant`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        body: {}
    });

    if (!response.ok) {
        let textResponse = await response.text()
        console.log("Response:", textResponse)
        if (response.status === 401 && textResponse === "Access token is expired." && retryCount < maxRetryCount) {
            // If the response is 401 Unauthorized, try to refresh the token
            console.log("Refreshing token...")
            // TODO: refresh the token and retry the request
        } else {
            console.error("Failed to create instant meeting.")
        }
        return;
    }

    const meetingDetails = await response.json();

    if (!meetingDetails?.id){
        console.error("Created meeting didn't return an id")
        return;
    }

    if (!meetingDetails?.password){
        console.error("Created meeting didn't return a password")
        return;
    }

    // Return the meeting details
    return {
        id: meetingDetails.id,
        password: meetingDetails.password
    };
};

/**
 * @param {*} retryCount
 * @returns {Promise<{id: string, email: string, displayName: string}>}
 */
const fetchZoomUserData = async (retryCount = 0) => {
    const accessToken = localStorage.getItem('zoomAccessToken');
    console.log("Fetching Zoom User Data...")
    // Check if accessToken is available
    if (!accessToken) {
        console.error("Access token not found.")
        return;
    }

    const response = await fetch(`${process.env.REACT_APP_CAREX_ZOOM_SERVICE_ENDPOINT}/users/me`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        }
    });

    if (!response.ok) {
        let textResponse = await response.text()
        console.log("Response:", textResponse)
        if (response.status === 401 && textResponse === "Access token is expired." && retryCount < maxRetryCount) {
            // If the response is 401 Unauthorized, try to refresh the token
            console.log("Refreshing token...")
            // TODO: refresh the token and retry the request
        } else {
            console.error("Failed to create instant meeting.")
        }
        return;
    }

    const userDetails = await response.json();

    if (!userDetails?.id){
        console.error("User data didn't return an id")
        return;
    }

    if (!userDetails?.email){
        console.error("User data didn't return an email")
        return;
    }

    if (!userDetails?.display_name){
        console.error("User data didn't return a display name")
        return;
    }

    // Return the user details
    return {
        id: userDetails.id,
        email: userDetails.email,
        displayName: userDetails.display_name
    };
};

/**
 * @param {*} retryCount
 * @returns {Promise<string>}
 */
const fetchZakToken = async () => {
    const accessToken = localStorage.getItem('zoomAccessToken');
    console.log("Retrieving Zak token...")
    const response = await fetch(`${process.env.REACT_APP_CAREX_ZOOM_SERVICE_ENDPOINT}/zak`, {
        headers: {
            'Authorization': `Bearer ${accessToken}`
        }
    });

    if (!response.ok) {
        let textResponse = await response.text()
        console.log("Response:", textResponse)
        if (response.status === 401 && textResponse === "Access token is expired." && retryCount < maxRetryCount) {
            // If the response is 401 Unauthorized, try to refresh the token
            console.log("Refreshing token...")
        } else {
            console.error("Failed to retrieve Zak token.")
        }

        return;
    }

    const zakToken = await response.json();

    if (!zakToken?.token){
        console.error("Zak token not found")
        return;
    }

    return zakToken.token;
}

const fetchZoomSignature = async (meetingNumber, role) => {
    const response = await fetch(`${process.env.REACT_APP_CAREX_ZOOM_SERVICE_ENDPOINT}/join/jwt`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ meetingNumber: meetingNumber.toString(), role: role })
    });

    if (!response.ok) {
        throw new Error('Failed to fetch Zoom signature');
    }

    console.log("Response:", response)
    const data = await response.json();
    return data.signature
};

const disableWaitingRoom = async (retryCount = 0) => {
    const accessToken = localStorage.getItem('zoomAccessToken');
    console.log("Disabling waiting room...")
    const response = await fetch(`${process.env.REACT_APP_CAREX_ZOOM_SERVICE_ENDPOINT}/user/enable-waiting-room`, {
        method: 'PATCH',
        headers: {
            'Authorization': `Bearer ${accessToken}`
        },
        body: JSON.stringify({ enableWaitingRoom: false })
    });

    if (!response.ok) {
            throw new Error(`API Request Failed: ${response.status}`);
    }

    console.log("Waiting room disabled.")
};

const endZoomMeeting = async (meetingId, zoomMeetingNumber) => {
    console.log("Ending meeting with id:", meetingId)
    const result = await fetch(`${process.env.REACT_APP_CAREX_ZOOM_SERVICE_ENDPOINT}/meetings/end`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            meetingId,
            zoomMeetingNumber,
            token: 'Bearer ' + localStorage.getItem('zoomAccessToken')
        }),
    });

    if (!result.ok) {
        console.error("Failed to end meeting.")
    }

    console.log("Meeting ended.")
    return result;
};

export  { createAndfetchMeetingDetails, fetchZoomUserData, fetchZakToken, fetchZoomSignature, disableWaitingRoom, endZoomMeeting };